import { useEffect } from 'react';
import { useT } from './i18n.tsx';

/** "Page · Sotuv paneli" in the browser tab and history. */
export function usePageTitle(page: string): void {
  const t = useT();
  useEffect(() => {
    document.title = t.app.pageTitle(page);
  }, [page, t]);
}
